import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;
class Vehicle {
  create = async (val: any) => {
    await axios({
      method: "post",
      url: `${API_URL}vehicle-master`,
      data: val,
    }).catch((e) => {
      const { message } = e.response.data;
      if (message.errorInfo) throw message.errorInfo[2];
      else throw e.message;
    });
  };
  sms = async (values:any) => {
    const res = await axios({
      method: "post",
      url: `${API_URL}send-sms`,
      data:values
      
    }).catch((e) => {
      const { message } = e.response.data;
      if (message.errorInfo) throw message.errorInfo[2];
      else throw e.message;
    });
  };
  edit = async (val: any, code: any) => {
    await axios({
      method: "put",
      url: `${API_URL}vehicle-master/${code}`,
      data: val,
    }).catch((e) => {
      const { message } = e.response.data;
      if (message.errorInfo) throw message.errorInfo[2];
      else throw e.message;
    });
  };
  get = async (code: any) => {
    const response = await axios({
      method: "get",
      url: `${API_URL}vehicle-master/${code}`,
    }).catch((e) => {
      throw e.message;
    });
    return response.data.vehicle;
  };
  getAll = async () => {
    const response = await axios({
      method: "get",
      url: `${API_URL}vehicle-master`,
    }).catch((e) => {
      throw e.message;
    });
    return response.data.vehicles;
  };
  search = async (keyword: any) => {
    const response = await axios({
      method: "get",
      url: `${API_URL}vehicle-master-search/${keyword}`,
    }).catch((e) => {
      throw e.message;
    });
    return response.data.vehicles;
  };
}
export default new Vehicle();
